// Listen for DOMContentLoaded to ensure elements are available
document.addEventListener('DOMContentLoaded', function(){
  // Initialize tooltips on page load
  initCertificationTooltips();
  
  // Create mobile modal container if it doesn't exist
  if (!document.getElementById('mobile-certification-modal')) {
    createMobileModal();
  }
  
  // Re-initialize tooltips when collapsible content is toggled
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a collapsible trigger
    if (event.target.closest('[data-toggle="collapse"], .collapsible-trigger, details summary, [aria-controls], .accordion__button')) {
      // Wait for the collapsible content to fully open
      setTimeout(function() {
        initCertificationTooltips();
      }, 300);
    }
  });
  
  // Also listen for Shopify section load/rerender events
  document.addEventListener('shopify:section:load', function() {
    initCertificationTooltips();
    // Recreate mobile modal when sections load
    if (!document.getElementById('mobile-certification-modal')) {
      createMobileModal();
    }
  });
  document.addEventListener('shopify:block:select', initCertificationTooltips);
});

// Function to create the mobile modal
function createMobileModal() {
  var modal = document.createElement('div');
  modal.id = 'mobile-certification-modal';
  modal.className = 'mobile-certification-modal';
  modal.innerHTML = `
    <div class="mobile-certification-modal-content">
      <div class="mobile-certification-modal-close">&times;</div>
      <div class="mobile-certification-modal-body"></div>
    </div>
  `;
  document.body.appendChild(modal);
  
  // Add styles if they don't exist
  if (!document.getElementById('mobile-certification-modal-styles')) {
    var styles = document.createElement('style');
    styles.id = 'mobile-certification-modal-styles';
    styles.textContent = `
      .mobile-certification-modal {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: 9999999;
        align-items: center;
        justify-content: center;
      }
      .mobile-certification-modal.active {
        display: flex;
      }
      .mobile-certification-modal-content {
        background-color: #fff;
        border-radius: 8px;
        width: 90%;
        max-width: 400px;
        max-height: 80%;
        overflow-y: auto;
        position: relative;
        padding: 20px;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
      }
      .mobile-certification-modal-close {
        position: absolute;
        top: 10px;
        right: 15px;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
        color: #888;
      }
      .mobile-certification-modal-body {
        margin-top: 10px;
        color: #333;
      }
    `;
    document.head.appendChild(styles);
  }
  
  // Add close event listener
  modal.querySelector('.mobile-certification-modal-close').addEventListener('click', function() {
    modal.classList.remove('active');
  });
  
  // Close modal when clicking outside the content
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      modal.classList.remove('active');
    }
  });
}

// Function to initialize certification tooltips
function initCertificationTooltips() {
  // Select all certification icon elements
  var certs = document.querySelectorAll('.custom-product-certification');
  var isMobile = window.innerWidth < 768;
  
  // Function to hide all tooltips (desktop only)
  function hideAllTooltips() {
    document.querySelectorAll('.custom-certification-tooltip').forEach(function(tip) {
      tip.style.opacity = '0';
      tip.style.visibility = 'hidden';
    });
  }
  
  // Function to position and show tooltip (desktop only)
  function showTooltip(cert, tooltip) {
    // Hide any other visible tooltips first
    hideAllTooltips();
    
    // Get the position of the certification icon
    var certRect = cert.getBoundingClientRect();
    var tooltipRect = tooltip.getBoundingClientRect();
    
    // Calculate the position for the tooltip
    var top = certRect.top - tooltipRect.height - 10;
    if (top < 10) {
      // If not enough space above, position below
      top = certRect.bottom + 10;
    }
    
    // Center horizontally relative to the certification icon
    var left = certRect.left + (certRect.width / 2) - (tooltipRect.width / 2);
    
    // Ensure the tooltip stays within the viewport
    if (left < 10) {
      left = 10;
    } else if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }
    
    // Position the tooltip
    tooltip.style.top = top + 'px';
    tooltip.style.left = left + 'px';
    tooltip.style.opacity = '1';
    tooltip.style.visibility = 'visible';
    tooltip.style.zIndex = '999999';
  }
  
  // Function to show mobile modal
  function showMobileModal(content) {
    var modal = document.getElementById('mobile-certification-modal');
    if (!modal) {
      createMobileModal();
      modal = document.getElementById('mobile-certification-modal');
    }
    
    modal.querySelector('.mobile-certification-modal-body').innerHTML = content;
    modal.classList.add('active');
  }
  
  certs.forEach(function(cert){
    var tooltip = cert.querySelector('.custom-certification-tooltip');
    
    if (!tooltip) return;
    
    // Remove existing event listeners by cloning and replacing the element
    var newCert = cert.cloneNode(true);
    cert.parentNode.replaceChild(newCert, cert);
    cert = newCert;
    tooltip = cert.querySelector('.custom-certification-tooltip');
    
    if (isMobile) {
      // Mobile behavior - show modal on click
      cert.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        showMobileModal(tooltip.innerHTML);
      });
    } else {
      // Desktop behavior - show tooltip on hover
      cert.addEventListener('mouseenter', function(event) {
        showTooltip(cert, tooltip);
      });
      
      cert.addEventListener('mouseleave', function() {
        tooltip.style.opacity = '0';
        tooltip.style.visibility = 'hidden';
      });
    }
  });
  
  // Add window resize listener to reinitialize on viewport changes
  window.addEventListener('resize', function() {
    var newIsMobile = window.innerWidth < 768;
    if (newIsMobile !== isMobile) {
      // Only reinitialize if mobile state changed
      setTimeout(initCertificationTooltips, 100);
    }
  });
}
